import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	transition: opacity 0.3s ease;

	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}
`;

const StyledMenuContainer = styled.div`
	padding: 20px 40px 20px;
`;

export { StyledContainer, StyledMenuContainer };
